import AlertTitle from '@mui/material/AlertTitle';

export { AlertTitle };
